<template>
  <SGPPageHeaderComponent
    titulo="Painel Backlog"
    textoBusca=""
    :mostrarBusca="false"
    :mostrarBotaoFiltroAvancado="true"
    @emitAbrirFiltro="abrirFiltro"
  />
</template>

<script>
export default {
  name: "HeaderBacklogComponent",

  methods: {
    abrirFiltro(val) {
      this.$emit('abrirFiltroEmit', val)
    },
  },
}
</script>
